import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SlickModule } from 'ngx-slick';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardsCreditActivationStep1Component } from './credit/activation/step1/step1.component';
import { CardsCreditActivationStep2Component } from './credit/activation/step2/step2.component';
import { CardsCreditActivationStep3Component } from './credit/activation/step3/step3.component';
import { CardsCreditComponent } from './credit/credit.component';
import { CardsCreditActivationDeclinedComponent } from './credit/activation/declined/declined.component';

@NgModule({
imports: [
		CommonModule,
		CurrencyMaskModule,
		SharedModule,
		RouterModule,
		MatCardModule,
		MatTableModule,
		MatCheckboxModule,
		FormsModule,
		ReactiveFormsModule,
		SlickModule.forRoot(),
],
declarations: [
	CardsCreditActivationStep1Component,
	CardsCreditActivationStep2Component,
	CardsCreditActivationStep3Component,
	CardsCreditComponent,
	CardsCreditActivationDeclinedComponent,
],
providers: [
],
entryComponents: [],
})
export class CardsActivationModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/cards-activation/cards-activation.module.ts